<template>
  <div class="content">
    <div class="banner">
      <div class="gradient-bg">
        <svg
            viewBox="0 0 100vw 100vw"
            xmlns='http://www.w3.org/2000/svg'
            class="noiseBg"
        >
          <filter id='noiseFilterBg'>
            <feTurbulence
                type='fractalNoise'
                baseFrequency='0.6'
                stitchTiles='stitch' />
          </filter>

          <rect
              width='100%'
              height='100%'
              preserveAspectRatio="xMidYMid meet"
              filter='url(#noiseFilterBg)' />
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" class="svgBlur">
          <defs>
            <filter id="goo">
              <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" />
              <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -8" result="goo" />
              <feBlend in="SourceGraphic" in2="goo" />
            </filter>
          </defs>
        </svg>
        <div class="gradients-container">
          <div class="g1"></div>
          <div class="g2"></div>
          <div class="g3"></div>
          <div class="g4"></div>
          <div class="g5"></div>
          <div class="interactive"></div>
        </div>
      </div>
      <div class="banner-txt">
        <div class="title">HURI虎锐 <span>隧道无人巡检机器人</span></div>
        <div class="info">
          随着人工智能、物联网技术的不断发展，智能轨道巡检将更加智能化，智能轨道巡检将能够与各种设备、系统进行集成，实现数据的共享和协同工作。
        </div>
      </div>
      <div class="img-right"><img src="../../assets/images/car.png" alt="" /></div>
    </div>
    <!--详细介绍-->
    <div class="model">
      <div class="model-title">
        <span class="title">系统组成与功能</span>
        <p class="sub-title">无人巡检智能系统组成与功能</p>
      </div>
      <div class="model-body">
        <el-row :gutter="100">
          <el-col :span="8" :xs="24">
            <div class="item-info">
              <div class="number">01</div>
              <div class="info-title">硬件设备</div>
              <div class="info-txt">
                硬件设备：包括无人巡检机器人、传感器、摄像头、边缘计算等，用于采集数据和图像信息以及实时识别分析。
              </div>
              <img src="../../assets/images/car/item1.png"/>
            </div>
          </el-col>
          <el-col :span="8" :xs="24">
            <div class="item-info">
              <div class="number">02</div>
              <div class="info-title">巡检平台</div>
              <div class="info-txt">
                巡检平台：包括数据分析、图像识别、远程控制等功能，用于远程控制巡检机器人和处理采集到的数据和图像信息。
              </div>
              <img src="../../assets/images/car/item2.png"/>
            </div>
          </el-col>
          <el-col :span="8" :xs="24">
            <div class="item-info">
              <div class="number">03</div>
              <div class="info-title">AI算法平台</div>
              <div class="info-txt">
                AI算法平台：针对采集到的相关数据进行训练，不断迭代识别模型。
              </div>
              <img src="../../assets/images/car/item3.png"/>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="model model-flex">
      <!---->
      <div class="model-left">
        <img src="../../assets/images/car/car.png" class="car"/>
        <div class="nav-list">
          <div class="nav-item" :class="{'active': index === iconActive}" v-for="(item,index) in iconList" :key="index" @click="sliderToItem(index)">{{item.title}}</div>
        </div>
      </div>
      <div class="model-right">
        <div class="model-title">
          <span class="title">无人巡检机器人</span>
          <p class="sub-title">我们研发的一款性能卓越的无人智能巡检机器人，不仅解决了市场现有产品的性能缺陷，还为巡检人员提供了显著提升工作效率的解决方案。</p>
        </div>
        <el-carousel ref="modelIcon" :interval="5000"  arrow="always" height="20.25vw" @change="iconActiveChange"    indicator-position="none" >
          <el-carousel-item ref="carousel" v-for="item in iconList" :key="item.title">
            <div class="icon-title"><span> {{ item.title }}</span></div>
            <div class="icon-info">{{item.content}}</div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="model ">
      <div class="top-select flex-left">
        <div class="model-title">
          <span class="title">巡检平台</span>
          <p class="sub-title">巡检平台利用前沿科技，驱动无人设备智能巡检机器人，实时监测、精准反馈。</p>
        </div>
        <div class="top-list">
          <div class="top-item" :class="{'active': index === inspectionActive}" v-for="(item, index) in inspectionList" :key="index" @click="inspectionActiveToItem(index)">
            <div class="item-title">{{ item.title }}</div>
            <div class="item-info">{{ item.dec }}</div>
          </div>
        </div>
      </div>
      <div class="has-img img-right">
        <div class="model-left" v-html="inspectionList[inspectionActive].content"></div>
        <div class="model-right">
          <el-carousel ref="modelInspectionActive" :interval="5000" arrow="never" height="100%" @change="inspectionActiveChange">
            <el-carousel-item v-for="(item, index) in inspectionList" :key="index">
              <img :src="item.img" alt="">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="model ">
      <div class="top-select flex-right">
        <div class="model-title">
          <span class="title">AI算法平台</span>
          <p class="sub-title">AI算法平台包含数据集、模型训练、模型库模块，它旨在帮助用户更高效地进行人工智能模型的开发、训练和管理。</p>
        </div>
        <div class="top-list">
          <div class="top-item" :class="{'active': index === algorithmActive}" v-for="(item, index) in algorithmList" :key="index" @click="algorithmActiveToItem(index)">
            <div class="item-title">{{ item.title }}</div>
            <div class="item-info">{{ item.dec }}</div>
          </div>
        </div>
      </div>
      <div class="has-img img-left">
        <div class="model-left"  v-html="algorithmList[algorithmActive].content"></div>
        <div class="model-right">
          <el-carousel ref="modelAlgorithmActive" :interval="5000" arrow="never" height="100%" @change="algorithmActiveChange">
            <el-carousel-item v-for="(item, index) in algorithmList" :key="index">
              <img :src="item.img" alt="">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="last-model">
      <div class="model-title center">
        <span class="title">产品特点</span>
        <p class="sub-title">巡检设备进入隧道后，利用摄像头采集图像与数据，实时显示于巡检平台，操作人员借此可全面掌握隧道情况。通过远控端，操作人员既能查看设备拍摄的实时画面，了解隧道内部状况，又能按需精准操控巡检机器人，按指定路线与任务巡检。</p>
      </div>
      <div class="model-body">
        <el-row :gutter="22">
          <el-col :span="8" :xs="24">
            <div class="last-item">
              <div class="last-title">
                <img src="../../assets/images/car/last1.png"/>
                <span>智控提效，降本增益</span>
              </div>
              <div class="last-info">
                凭借远程操控与自主导航技术，无人巡检机器人突破人力限制，高效覆盖地铁轨道，大幅削减人力及相关成本，实现运维效益最大化。
              </div>
            </div>
          </el-col>
          <el-col :span="8" :xs="24" >
            <div class="last-item">
              <div class="last-title">
                <img src="../../assets/images/car/last2.png"/>
                <span>数据驱动，模型进化</span>
              </div>
              <div class="last-info">
                基于 AI 算法平台，机器人利用运行中采集的海量数据，借助深度学习算法持续优化模型，精准识别轨道病害，提升检测精度与可靠性。
              </div>
            </div>
          </el-col>
          <el-col :span="8" :xs="24">
            <div class="last-item">
              <div class="last-title">
                <img src="../../assets/images/car/last3.png"/>
                <span>全维感知，即时预警</span>
              </div>
              <div class="last-info">
                搭载多类型传感器与高清摄像头，机器人全方位实时监测轨道状况，一旦发现异常，毫秒级回传信息，确保监控人员及时响应。
              </div>
            </div>
          </el-col>
          <el-col :span="12" :xs="24">
            <div class="last-item">
              <div class="last-title">
                <img src="../../assets/images/car/last4.png"/>
                <span>开放架构，多元适配</span>
              </div>
              <div class="last-info">
                采用模块化、开放式设计，机器人可便捷集成各类专业检测设备，灵活应对轨道交通从轨道到附属设施的多样化巡检需求。
              </div>
            </div>
          </el-col>
          <el-col :span="12" :xs="24">
            <div class="last-item">
              <div class="last-title">
                <img src="../../assets/images/car/last5.png"/>
                <span>智能防护，安全无虞</span>
              </div>
              <div class="last-info">
                无人巡检模式消除人为安全隐患，结合智能避障与故障自诊断技术，为地铁轨道巡检筑牢安全防线，保障运营安全稳定。
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <footerView></footerView>
  </div>
</template>

<script>
import footerView from "@/components/footerView.vue";
export default {
  name: "ExplorationVehicle",
  components:{
    footerView
  },
  data(){
    return {
      iconActive:0,
      iconList:[
        {title:"无人化", content:"无需人入隧道，可远程操控自主巡检，无人跟随规避环境风险，降低人力成本，效率提升超 80%"},
        {title:"轻量化", content:"采用轻质材料，单机可折叠，灵活适配复杂隧道环境，部署转运便捷，单人即可操作，降低作业成本。"},
        {title:"智能化", content:"利用现代检测设备，与云平台互联，具备单机/双机作业模式，自动定位上传，三操控模式（远程平台操控、中距离红外操控、近距商手环伴随）。"},
        {title:"体系化", content:"构建 “巡检 - 分析 - 反馈 - 优化” 闭环，创建驱控一体、边端融合、双云协同、多维物联的新体系。"},
        {title:"模块化", content:"模块化设计能快速搭载设备，适配多场景，提升设备利用率。可以承担结构、轨道、通号巡检，及负重、应急支援等不同任务。"},
      ],
      inspectionList:[
        {
          title: "远程控制",
          dec:'摄像头实时传图，远程精准操控。',
          content:'<p>巡检机器人进入隧道后，采用摄像头采集图像和数据。这些信息会实时显示在巡检平台，方便操作人员对隧道情况进行全面掌握。</p>' +
              '<p>通过远控端，操作人员可以查看到巡检设备拍摄的实时画面，从而对隧道内部的情况进行全面了解。同时，操作人员可以根据需要对设备进行精确的操控，使其按照指定的路线和任务进行巡检。</p>',
          img:'/static/Inspection1.png'
        },
        {
          title: "轨道底板监测",
          dec:'算法识别异常，远程实时推送。',
          content:'<p>巡检过程中，边缘计算端调用算法模型，算法调用摄像头获取画面，并对画面进行识别分析；\n</p>' +
              '<p>如果算法识别到异常，则将异常的识别结果保存，并通过网络推送到远程服务器；\n</p>' +
              '<p>服务器接收到巡检端的识别结果，将数据保存到数据库，并推送给远程控制端；\n</p>' +
              '<p>远程控制端从服务器获取到识别分析结果后，在页面上进行展示。</p>',
          img:'/static/Inspection2.png'
        },
        {
          title: "多源定位",
          dec:'算法测距，射频识别。',
          content:'<p>在无人小车进行巡检过程中，系统会采用相应的逻辑算法计算行驶的距离，并通过射频识别技术识别相应芯片以及利用算法识别技术，实现无人小车的融合定位。</p>',
          img:'/static/Inspection3.png'
        },
        {
          title: "热成像检测",
          dec:'实时监测，超温报警推送平台。',
          content:'<p>热成像模块依托于集成于无人巡检机器人的热成像仪，借助无人巡检机器人的车载边缘计算单元，实时将热成像视频流推送至巡检平台。</p>' +
              '<p>远程控制人员可在巡检平台页面同步查看热像视频流。当监测到对应区域内的温度超过设定阈值时，系统将实时生成温度报警信息并上传至巡检平台。</p>',
          img:'/static/Inspection4.png'
        },
        {
          title: "三轨检测",
          dec:'激光拉线测距，数据图表展示。',
          content:'<p>三轨形变检测模块融合了激光测距仪、拉线测距仪及步进电机等精密设备，经由严谨流程，精确获取三轨拉出值与导高值。</p>' +
              '<p>此模块支持定点与手动两种检测模式。在任务重预设定点位置，待检测小车抵达，自动启动形变检测。</p>' +
              '<p>手动模式下，用户通过远控端点击按钮，即可触发单次三轨形变检测任务，操作便捷高效。</p>' +
              '<p>检测所得三轨形变数据，上传后台服务器，以图表直观展示，供检测人员便捷查阅。</p>',
          img:'/static/Inspection5.png'
        }
      ],
      inspectionActive: 0,
      algorithmList: [
        {
          title: "数据集",
          dec:'创建、标注，助模型训练。',
          content:'<p>数据集模块具备创建新数据集的功能，以便对大量样本数据进行有序组织与管理，以满足模型训练需求。</p>' +
              '<p>在上传数据集文件后，用户可在平台上为每个文件进行标注，以便供模型训练模块使用。</p>',
          img:'/static/algorithm1.png'
        },
        {
          title: "模型训练",
          dec:'选数据、调参、转换存储。',
          content:'<p>在模型训练模块中，可根据需求选择各类数据集，调整相应的训练参数以实施各类模型训练。\n</p>' +
              '<p>经训练后的优质模型将进行模型转换，并将转换后的模型储存在模型库中，以供其他用户使用。</p>',
          img:'/static/algorithm2.png'
        },
        {
          title: "模型库",
          dec:'多模型、多功能、可迭代。',
          content:'<p>模型库为广大应用场景提供了一系列完备的模型，包括但不限于异物识别、混凝土渗水识别以及混凝土裂缝识别等。</p>' +
              '<p>库内功能齐全，涵盖模型的导入导出、更新、版本管理等基础操作。预设了多种常用AI模型，整合了典型的机器学习模型，同时支持依据现有模型和数据进行重新训练，生成新模型，从而实现模型的不断迭代和优化，提升其在应用场景下的表现。</p>',
          img:'/static/algorithm3.png'
        },
      ],
      algorithmActive:0
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    const interBubble = document.querySelector('.interactive');
    let curX = 0;
    let curY = 0;
    let tgX = 0;
    let tgY = 0;

    const move = () => {
      curX += (tgX - curX) / 20;
      curY += (tgY - curY) / 20;
      interBubble.style.transform = `translate(calc(${Math.round(curX)}px - 30vw), ${Math.round(curY)}px)`;
      requestAnimationFrame(move);
    };

    window.addEventListener('mousemove', (event) => {
      tgX = event.clientX;
      tgY = event.clientY;
    });

    move();
  },
  methods:{
    iconActiveChange(e){
      this.iconActive = e
    },
    inspectionActiveChange(e){
      this.inspectionActive = e
    },
    algorithmActiveChange(e){
      this.algorithmActive = e
    },
    sliderToItem(index){
      this.$refs.modelIcon.setActiveItem(index)
    },
    inspectionActiveToItem(index){
      this.$refs.modelInspectionActive.setActiveItem(index)
    },
    algorithmActiveToItem(index){
      this.$refs.modelAlgorithmActive.setActiveItem(index)
    }
  }
}
</script>

<style scoped lang="scss">
.content{
  background: rgb(0, 17, 32);
}

* {
  margin: 0;
  padding: 0;
  outline: none;
  list-style: none;
  text-decoration: none;
  box-sizing: border-box;
  color: #FFF;
  background: transparent;
  border: none;
}

html, body {
  font-family: "Dongle", sans-serif;
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
}

body {
  background: #FFF;
  font-family: "Montserrat", sans-serif;
  overflow: hidden;
}

h1, h2, h3 {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
}

.card {
  position: absolute;
  z-index: 10;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  user-select: none;
  max-width: 600px;
  padding: 48px;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  border-radius: 8px;
  box-shadow: 0 4px 90px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
.card:before {
  content: "";
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: white;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, white 34%, white 89%, rgba(255, 255, 255, 0) 100%);
  opacity: 0.3;
  filter: blur(0.5px);
  mix-blend-mode: hard-light;
}
.card .noise {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 1;
  opacity: 0.1;
}
.card .content {
  position: relative;
  z-index: 2;
  text-shadow: -3px 0px 2px rgba(0, 0, 0, 0.1);
}

h1 {
  font-size: 3rem;
  margin-bottom: 16px;
}

p {
  line-height: 1.6;
}

@keyframes moveInCircle {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes moveVertical {
  0% {
    transform: translateY(-50%);
  }
  50% {
    transform: translateY(50%);
  }
  100% {
    transform: translateY(-50%);
  }
}
@keyframes moveHorizontal {
  0% {
    transform: translateX(-50%) translateY(-10%);
  }
  50% {
    transform: translateX(50%) translateY(10%);
  }
  100% {
    transform: translateX(-50%) translateY(-10%);
  }
}
.gradient-bg {
  width: 100vw;
  height: 100vh;
  position: absolute;
  overflow: hidden;
  top: 0;
  left: 0;
  background: linear-gradient(40deg, rgb(8, 10, 15), rgb(0, 17, 32));
}
.gradient-bg .svgBlur {
  display: none;
}
.gradient-bg .noiseBg {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1;
  mix-blend-mode: soft-light;
  opacity: 0.3;
}
.gradient-bg .gradients-container {
  filter: url(#goo) blur(40px);
  width: 100%;
  height: 100%;
}
.gradient-bg .g1 {
  position: absolute;
  background: radial-gradient(circle at center, rgba(18, 113, 255, 0.8) 0, rgba(18, 113, 255, 0) 50%) no-repeat;
  mix-blend-mode: hard-light;
  width: 80%;
  height: 80%;
  top: 10%;
  left: 10%;
  transform-origin: center center;
  animation: moveVertical 30s ease infinite;
  opacity: 1;
}
.gradient-bg .g2 {
  position: absolute;
  background: radial-gradient(circle at center, rgba(74, 140, 255, 0.8) 0, rgba(74, 134, 255, 0) 50%) no-repeat;
  mix-blend-mode:hard-light;
  width: 80%;
  height: 80%;
  top: 10%;
  left: 10%;
  transform-origin: calc(50% - 400px);
  animation: moveInCircle 20s reverse infinite;
  opacity: 1;
}
.gradient-bg .g3 {
  position: absolute;
  background: radial-gradient(circle at center, rgba(87, 232, 250, 0.8) 0, rgba(73, 234, 252, 0) 50%) no-repeat;
  mix-blend-mode:hard-light;
  width: 80%;
  height: 80%;
  top: calc(10% + 200px);
  left: calc(10% - 500px);
  transform-origin: calc(50% + 400px);
  animation: moveInCircle 40s linear infinite;
  opacity: 1;
}
.gradient-bg .g4 {
  position: absolute;
  background: radial-gradient(circle at center, rgba(50, 160, 220, 0.8) 0, rgba(50, 160, 220, 0) 50%) no-repeat;
  mix-blend-mode: hard-light;
  width: 80%;
  height: 80%;
  top: calc(50% - 80% / 2);
  left: calc(50% - 80% / 2);
  transform-origin: calc(50% - 200px);
  animation: moveHorizontal 40s ease infinite;
  opacity: 0.7;
}
.gradient-bg .g5 {
  position: absolute;
  background: radial-gradient(circle at center, rgba(45, 107, 255, 1) 0, rgba(45, 107, 255, 0) 50%) no-repeat;
  mix-blend-mode: hard-light;
  width: 100%;
  height: 100%;
  top: calc(50% - 80%);
  left: calc(50% - 80%);
  transform-origin: calc(50% - 800px) calc(50% + 200px);
  animation: moveInCircle 20s ease infinite;
  opacity: 1;
}
.gradient-bg .interactive {
  position: absolute;
  background: radial-gradient(circle at center, rgba(73, 234, 252, .8) 0, rgba(73, 234, 252, 0) 50%) no-repeat;
  mix-blend-mode: hard-light;
  width: 100%;
  height: 100%;
  top: -50%;
  left: -50%;
  opacity: 0.7;
}
.banner{
  position: relative;
  height: 56.25vw;
  overflow: hidden;
  background: #02121E;
  display: flex;
  align-items: center;
  justify-content: center;
  .img-right{
    margin-left: 6%;
    position: relative;
    img{
      height: 39.375vw;
      width: auto;
    }
  }
}
.banner-txt{
  width: 580px;
  padding: 16px 24px;
  position: relative;
  background: rgba(38,70,126,0.2);
  border-radius: 8px;
  left: 6%;
  .title{
    font-size: 24px;
    span{
      font-size: 32px;
      display: block;
    }
  }
  .info{
    font-size: 16px;
    text-align: left;
    width: 100%;
    line-height: 2;
    margin-top: 16px;
  }
}
.model{
  min-height: 52vw;
  padding: 120px 96px 56px;
  &.model-flex{
    display: flex;
  }
  &:nth-child(2n){
    background: url(../../assets/images/car/BG.png) no-repeat center;
    background-size: 100% 100%;
  }
  &:nth-child(3){
    background: #161c27 url(../../assets/images/car/bg-right1.png) no-repeat center;
    background-size: 100% auto ;
  }
  &:nth-child(5){
    background: url(../../assets/images/car/bgright-2.png) no-repeat center;
    background-size: 100% 100% ;
  }
  .model-title{
    margin-bottom: 84px;
    .title{
      background: url(../../assets/images/car/model-title.png) no-repeat left center;
      background-size: auto 32px;
      font-size: 32px;
      line-height: 40px;
      position: relative;
      padding-left: 26px;
      margin-bottom: 20px;
      &:after{
        position: absolute;
        content: '';
        width: calc(100% - 20px);
        height: 8px;
        background: rgba(61, 145, 255, .33);
        bottom: 0;
        left: 26px;
      }
    }
    .sub-title{
      font-size: 12px;
      color: rgba(255,255,255,.6);
    }
  }
}
.model-body{
  .el-col{
    &:nth-child(1){
      .info-title{
        &:after{
          animation: moveLine 3s infinite;
        }
      }
    }
    &:nth-child(2){
      .info-title{
        &:after{
          animation: moveLine 3s -1s infinite;
        }
      }
    }
    &:nth-child(3){
      .info-title{
        &:after{
          animation: moveLine 3s -2s infinite;
        }
      }
    }
  }
  .item-info{
    .number{
      font-weight: 600;
      font-size: 24px;
      color: #3D91FF;
      line-height: 40px;
    }
    img{
      width: 100%;
      height: auto;
    }
    .info-title{
      line-height: 72px;
      font-size: 24px;
      position: relative;
      margin-bottom: 30px;
      overflow: hidden;
      width: 178px;
      &:before{
        width: 178px;
        height: 2px;
        background: rgba(255,255,255,.2);
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
      }
      &:after{
        width: 86px;
        height: 2px;
        background: rgba(61, 145, 255, 1);
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        transform: translateX(0)
      }
    }
    .info-txt{
      height: 90px;
      font-size: 14px;
      color: #FFFFFF;
      line-height: 22px;
      opacity: .6;
      margin-bottom: 44px;
    }
  }
}
.last-model{
  min-height: 77vh;
  background: url(../../assets/images/car/BG1.png) no-repeat;
  background-size:  100% auto;
  padding: 90px 95px;
  .model-title{
    margin-bottom: 84px;
    text-align: center;
    .title{
      background: url(../../assets/images/car/model-title.png) no-repeat left center;
      background-size: auto 32px;
      font-size: 32px;
      line-height: 66px;
      position: relative;
      padding-left: 26px;
      margin-bottom: 20px;
    }
    .sub-title{
      font-size: 12px;
      color: rgba(255,255,255,.6);

    }
  }
  .last-item{
    min-height: 140px;
    padding: 32px 24px;
    background: rgba(255,255,255,.1);
    border-radius: 12px;
    backdrop-filter: blur(29px);
    margin-bottom: 22px;
    .last-title{
      display: flex;
      align-items: center;
      font-size: 24px;
      margin-bottom: 8px;
      img{
        width: 44px;
        height: 44px;
        margin-right: 8px;
      }
    }
    .last-info{
      font-size: 14px;
      color: #FFFFFF;
      line-height: 22px;
      opacity: .6;
    }
  }
}
@keyframes moveLine {
  0%{
    transform: translateX(0);
  }
  100%{
    transform: translateX(200%);
  }
}
.model-left{
  width: 50vw;
  display: flex;
  align-items: center;
  position: relative;
  .car{
    width: 50%;
    height: auto;
  }
  .nav-list{
    height: 100%;
    width: 100%;
    position: absolute;
    left: 75px;
    top: 45px;
    .nav-item{
      width: 80px;
      height: 80px;
      position: absolute;
      padding-top: 80px;
      text-align: center;
      font-size: 18px;
      cursor: pointer;

      &:nth-child(1){
        background: url(../../assets/images/car/icon1-ac.png) no-repeat top center;
        background-size: 100% auto;
        left: 38%;
        top: 0;
        &:hover,&.active{
          background: url(../../assets/images/car/icon2.png) no-repeat top center;
          background-size: 100% auto;
        }
      }
      &:nth-child(2){
        background: url(../../assets/images/car/icon3-ac.png) no-repeat top center;
        background-size: 100% auto;
        left: 54%;
        top: 14%;
        &:hover,&.active{
          background: url(../../assets/images/car/icon3.png) no-repeat top center;
          background-size: 100% auto;
        }
      }
      &:nth-child(3){
        background: url(../../assets/images/car/icon4-ac.png) no-repeat top center;
        background-size: 100% auto;
        left: 60%;
        bottom:48%;
        &:hover,&.active{
          background: url(../../assets/images/car/icon4.png) no-repeat top center;
          background-size: 100% auto;
        }
      }
      &:nth-child(4){
        background: url(../../assets/images/car/icon5-ac.png) no-repeat top center;
        background-size: 100% auto;
        left: 54%;
        bottom: 22%;
        &:hover,&.active{
          background: url(../../assets/images/car/icon5.png) no-repeat top center;
          background-size: 100% auto;
        }
      }
      &:nth-child(5){
        background: url(../../assets/images/car/icon6-ac.png) no-repeat top center;
        background-size: 100% auto;
        left: 38%;
        bottom: 6%;
        &:hover,&.active{
          background: url(../../assets/images/car/icon6.png) no-repeat top center;
          background-size: 100% auto;
        }
      }
    }
  }

}
.model-right{
  ::v-deep .el-carousel__item{
    display: flex;
    flex-direction: column;
    padding-top: 54px;
    .icon-title{
      font-size: 24px;
      line-height: 44px;
      margin-bottom: 10px;
      span{
        background-image: linear-gradient(to right, #3D91FF, #49EAFC);
        color: transparent;
        -webkit-background-clip: text;
        background-clip: text;
      }
    }
    .icon-info{
      font-size: 14px;
      color: #FFFFFF;
      line-height: 22px;
      opacity: .6;
    }
  }
  ::v-deep .el-carousel__indicators--horizontal{
    display: none;
  }
  ::v-deep .el-carousel__arrow--left{
    top: 70%;
    left: 0;
    width: 34px;
    height: 34px;
    background: #383D40;
    border-image: linear-gradient(180deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)) 1 1;
  }
  ::v-deep .el-carousel__arrow--right{
    top: 70%;
    right: calc(100% - 100px);
    width: 34px;
    height: 34px;
    background: #383D40;
    border-image: linear-gradient(180deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)) 1 1;
  }
}
.top-select{
  width: 100%;
  .top-list{
    display: flex;
    margin-bottom: 80px;
    padding-top: 20px;
    border-top: 1px solid;
    border-image: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(61, 145, 255, 1), rgba(255, 255, 255, 0)) 1;
    .top-item{
      background: transparent;
      border-radius: 12px;
      padding: 8px 16px;
      margin-right: 30px;
      cursor: pointer;
      position: relative;

      &:last-child{
        margin-right: 0;
      }
      .item-title{
        font-size: 16px;
        margin-bottom: 8px
      }
      .item-info{
        font-size: 12px;
        opacity: .5;
      }
      &.active{
        background: #383D40;
        &:before{
          content: '';
          position: absolute;
          width: 16px;
          height: 16px;
          background: #3D91FF;
          box-shadow: 0 0 11px 5px rgba(61,145,255,0.58);
          top: -28px;
          left: 0;
          border-radius: 50%;
        }
      }
    }
  }
  .model-title{
    margin-bottom: 40px;
  }
  &.flex-right{
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    .top-list{
      justify-content: flex-end;
      width: 100%;
    }
    .model-title{
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }
  }
}
.has-img{
  width: 1748px;
  height: 574px;
  margin: auto;
  justify-content: space-between;
  display: flex;

  .model-left{
    width: 40%;
    font-size: 14px;
    text-align: justify;
    opacity: .8;
    flex-direction: column;
    padding-top: 100px;
    line-height:22px;

    ::v-deep p{
      width: 100%;

    }
  }
  .model-right{
    height: 563px;
    width: 1000px;
    .el-carousel{
      height: 100%;
      ::v-deep .el-carousel__item{
        padding-top: 0;
        text-align: center;
         
      }
    }
  }
  &.img-right{
    background: url(../../assets/images/car/right.png) no-repeat ;
    background-size: 100% auto;

  }
  &.img-left{
    background: url(../../assets/images/car/left.png) no-repeat ;
    background-size: 100% auto;
    flex-direction: row-reverse;

  }
}

@media screen and (max-width: 1440px){
 
}

::v-deep .el-carousel__mask{
  background: transparent!important;
}
::v-deep .el-carousel__item.is-in-stage{
  opacity: .3;
  &.is-active{
    opacity: 1;
  }
}
@media screen and (max-width: 1400px){
  .banner-txt{
    left: 40px;
  }
  .model-body .item-info .info-txt{
    margin-bottom: 24px;
  }
  .has-img{
    width: 100%;
    height: 32vw;
    .model-right {
      width: 55vw;
      img{
        width: 55vw;
        height:31.35vw;
      }
    }
  }
  .model-left{
    .nav-list{
      .nav-item{

        &:nth-child(1){
          left: 10%;
          top: -14%;
        }
        &:nth-child(2){
          left: 46%;
          top: 0;
        }
        &:nth-child(3){
          left: 60%;
          bottom:48%;
        }
        &:nth-child(4){
          left: 46%;
          bottom: 13%;
        }
        &:nth-child(5){
          left: 10%;
          bottom: -2%;
        }
      }
    }
  }
  .last-model{
    background-size: auto 100%;
    background-position: center ;
    .sub-title{
      width: 75%;
      margin: auto;
    }
  }
}
/* 大屏幕PC适配 */
@media screen and (min-width: 1600px) {
  .model {
    padding: 80px 30px;
  }
  .model-body {
    .item-info {
      padding: 0 24px;
    }
  }
}

/* 中屏幕PC适配 (1400-1599px) */
@media screen and (max-width: 1599px) and (min-width: 1400px) {
  .model {
    padding: 70px 25px;
  }
}

/* 小屏幕PC适配 (1200-1399px) */
@media screen and (max-width: 1399px) and (min-width: 1200px) {
  .model {
    padding: 60px 20px;
  }
}

/* 大屏平板适配 (1025-1199px) */
@media screen and (max-width: 1199px) and (min-width: 1025px) {
  .last-model {
    .model-title{
      margin-bottom: 30px;
    }
    .last-item{
      .last-title{
        font-size: 18px;
        line-height: 32px;
        height: 32px;
          img{
            width: 26px;
            height: 26px;
          }
      }
    }
    
  }
    .model-body{
      .el-row{
        margin: 0 -16px!important;
        .el-col{
          padding: 0 8px!important;
          .info-title{
            margin-bottom: 12px;
            font-size: 18px;
            line-height: 32px;
            height: 32px;
          }
          .info-txt{
            margin-bottom: 8px;
            height: 84px;
          }
        }
      }
    } 
  .model {
    padding: 40px 15px;
    min-height: 26vw;
    .model-left{
      padding-top: 0;
      :v-deep p{
        margin-bottom: 8px;
      }
      .nav-list{
        left: 50px;
        top: 30px;
         .nav-item{
          width: 60px;
          padding-top: 60px;
         }
      }
    }
    .model-right { 
      ::v-deep .el-carousel__arrow--left, ::v-deep .el-carousel__arrow--right{
        top: 90%; 
      }
    } 
  } 
  .model-left,
  .model-right {
    width: 100%;
    margin-bottom: 30px;
  }
  
}

/* 平板设备适配 (769-1024px) */
@media screen and (max-width: 1024px) and (min-width: 769px) {
   .last-model {
    .model-title{
      margin-bottom: 30px;
    }
    .last-item{
      .last-title{
        font-size: 18px;
        line-height: 32px;
        height: 32px;
          img{
            width: 26px;
            height: 26px;
          }
      }
    }
    
  }
  .model {
    padding: 40px 16px;
    .model-title{
      margin-bottom: 24px;
    }
    .model-body{
      .el-row{
        margin: 0 -16px!important;
        .el-col{
          padding: 0 8px!important;
          .info-title{
            margin-bottom: 12px;
            font-size: 18px;
            line-height: 32px;
            height: 32px;
          }
          .info-txt{
            margin-bottom: 8px;
            height: 84px;
          }
        }
      }
    } 
    .model-left{
      padding-top: 0;
      .nav-list{
        left: 70px;
        top: 30px;
         .nav-item{
            width: 60px;
            padding-top: 48px;
            font-size: 14px;
            background-size: 48px auto;
         }
      }
    }
  }  
  .model-right { 
    padding-left: 32px;
    ::v-deep .el-carousel__item{
      padding-top: 32px;
    }
    ::v-deep .el-carousel__arrow--left, ::v-deep .el-carousel__arrow--right{
        top: 90%; 
      }
  }
  .top-select {
    flex-direction: column;
    align-items: center;
  }
  .banner-txt{
    .title{
      font-size: 16px;
      line-height: 24px;
      span{
        font-size: 24px;
      }
    }
    .info{
      font-size: 14px;
      line-height: 24px;
    }
  }
}

@media screen and (max-width: 768px){
  .banner {
    height: 110vw;
    background: url(../../assets/images/product/banner-m.png) no-repeat;
    background-size: 100% auto;
    padding-top: 30px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    .banner-txt{
      width: 80%;
      left: 0;
      top: 40px;
      .title{ 
        font-size: 14px; 
        line-height: 24px;
        span{
          font-size: 20px;
        }
      }
    }
    .img-right{
      width: 100%;
      img{
        width: calc(100vw - 32px);
        height: calc((100vw - 32px) * 0.57);
      }
    }
    .title {
      font-size: 18px;
      line-height: 30px;
    }

    .info {
      font-size: 12px;
      margin-bottom: 0;
    }
  }
  .model{
    padding: 32px 16px 24px;
    background: url(../../assets/images/car/BG.png) no-repeat center!important;
    background-size: 100% 100% !important;
    .model-body .item-info .info-title:before,.model-body .item-info .info-title:after{
      display: none;
    }
    &:nth-child(3){
      .model-left{
        display: none;
      }
    }
    .model-title{
      margin-bottom: 16px;
      .title{
        font-size: 28px;
        line-height: 60px;
        background-size: 10px auto ;
        padding-left: 14px;
        &:after{
          display: none;
        }
      }
    }
    .model-right{
      ::v-deep .el-carousel__item{
        padding-top: 20px;
      }
       ::v-deep .el-carousel__arrow--left, ::v-deep .el-carousel__arrow--right{
        top: 90%; 
      }
      ::v-deep .el-carousel__container{
       height: 56vw!important;
      }
    }
    .model-left{
      ::v-deep p{
        margin: 0;
      }
    }
    .model-body{
      overflow: hidden;

     
      .item-info{
        margin-bottom: 0;
        .number{
          font-size: 28px;
          line-height: 30px;
        }
        .info-title{
          font-size: 24px;
          line-height: 40px;
          margin-bottom: 0;
        }
        .info-txt{
          font-size: 14px;
          line-height: 16px;
          height: auto;
          margin-bottom: 8px;
        }
      }
    }
  }
  .last-model{
    padding: 80px 16px 40px;
    background-size: 100% 100%;
   .sub-title{
     width: 90%;
   }
    .model-title{
      margin-bottom: 16px;
      .title{
        font-size: 28px;
        line-height: 40px;
        margin-bottom: 8px;
        background-size: 10px auto ;
        padding-left: 14px;
      }
    }
    .last-title{
      display: flex;
      align-items: center;
      font-size: 16px;
      margin-bottom: 8px;
    }
    .last-info{
      font-size: 14px;
      color: #FFFFFF;
      line-height: 22px;
      opacity: .6;
    }
    img{
      height: 40px;
      width: auto;
    }
  }
  .top-select{
    .top-list{
      margin-bottom: 20px; 
      border-image: linear-gradient(90deg, rgba(61, 145, 255, .8) 0, rgb(61, 145, 255), rgba(255, 255, 255, 0)) 1;
    }
    .top-item{
      padding: 4px 4px!important;
      border-radius: 2px!important;
      margin-right: 2px!important;
      .item-info{
        display: none!important;;

      }
      .item-title{
        margin-bottom: 0!important;
        font-size: 12px!important;
        text-align: center;

      }
      &.active{
        display: block;
      }
    }

  }
  .has-img{
    display: flex;
    flex-direction: column!important;
    width: 100% !important;
    height: auto!important;
    background: transparent!important;
    .model-left{
      padding-top: 0!important;
      width: 100% !important;
    }
    .model-right{
      width: 100% !important;
      height: 56vw !important;
      ::v-deep .el-carousel__container{
        height: 56vw !important;
      }
      ::v-deep .el-carousel__item{
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .top-select.flex-right{
    .model-title{
      align-items: flex-start;
      width: 100%;
    }
    .top-list{
      justify-content: flex-start;
    }
  }
}
</style>
